<textarea
    *ngIf="field.input.type === inputType.MULTISELECT || field.input.type === inputType.MULTISELECT_SEARCH; else readOnlyText"
    class="form-control"
    rows="3"
    [value]="getReadOnlyDisplayValue()"
    readonly>
</textarea>

<ng-template #readOnlyText>
    <p class="read-only">{{ getReadOnlyDisplayValue() }}</p>
</ng-template>
